import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { formatResourcePath } from 'src/utils/regex';
import { SubscriptionItemPricingOverride } from 'src/features/subscriptionItemPricingOverrides/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/:itemId/pricing-override/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    subscriptionId: string;
    itemId: string;
}

const queryFn = ({ subscriptionId, itemId, ...params }: DTO): Promise<ListResponseAPI<SubscriptionItemPricingOverride>> => {
    return axios.get(formatResourcePath(RESOURCE, { subscriptionId, itemId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_SUBSCRIPTION_ITEM_PRICING_OVERRIDES_RESOURCE,
    useQueryHook as useListSubscriptionItemPricingOverrides,
};
